import React from 'react';
import { Box, ToggleButton, ToggleButtonGroup, Tooltip } from '@mui/material';
import TableRowsIcon from '@mui/icons-material/TableRows';
import ViewKanbanIcon from '@mui/icons-material/ViewKanban';
import ViewModuleIcon from '@mui/icons-material/ViewModule';
import { useSearchParams } from 'react-router-dom';

const JobsViewToggle = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const view = (searchParams.get('View') || 'table').toLowerCase();

  const handleChange = (_, next) => {
    if (!next) return;
    searchParams.set('View', next);
    setSearchParams(searchParams);
  };

  return (
    <Box sx={{width: 'fit-content' , display: 'flex', alignItems: 'start'}}>

    <ToggleButtonGroup size="small" value={view} exclusive onChange={handleChange} aria-label="jobs view">
      <Tooltip title="Board">
        <ToggleButton value="board" aria-label="board view">
          <ViewKanbanIcon fontSize="small" />
        </ToggleButton>
      </Tooltip>
      <Tooltip title="Table">
        <ToggleButton value="table" aria-label="table view">
          <TableRowsIcon fontSize="small" />
        </ToggleButton>
      </Tooltip>
      
      <Tooltip title="Cards">
        <ToggleButton value="cards" aria-label="cards view">
          <ViewModuleIcon fontSize="small" />
        </ToggleButton>
      </Tooltip>
    </ToggleButtonGroup>
        </Box>

  );
};

export default JobsViewToggle;
